import { ButtonPrimary, type ButtonProps } from "@ui/elements";
import { useFormState } from "react-final-form";

export function SubmitButton({ className, children, ...props }: ButtonProps) {
  const formState = useFormState();
  return (
    <ButtonPrimary type="submit" className={className} loading={formState.submitting} {...props}>
      {children}
    </ButtonPrimary>
  );
}

export default SubmitButton;
